import { render, staticRenderFns } from "./gallery-item.vue?vue&type=template&id=a5325fca&scoped=true&"
import script from "./gallery-item.ts?vue&type=script&lang=ts&"
export * from "./gallery-item.ts?vue&type=script&lang=ts&"
import style0 from "./gallery-item.scss?vue&type=style&index=0&id=a5325fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5325fca",
  null
  
)

export default component.exports